import { IApplicationNotificationState } from '../../states/containersState';
import * as application from '../../actions/containers/application';
import * as commonTypes from '../../../shared/types';

const initialState: IApplicationNotificationState = {
    notifications: []
};

export function notificationReducer(state: IApplicationNotificationState = initialState,
                                   action: application.Actions): IApplicationNotificationState {
    switch (action.type) {
        case application.ActionTypes.POP_NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                notifications: state.notifications.concat(action.payload)
              });
        case application.ActionTypes.RESET_NOTIFICATION:
            return initialState;
        default:
            return state;
    }
};

export const getNotifications = (applicationContainerNotificationState: IApplicationNotificationState): commonTypes.IToastr[] => applicationContainerNotificationState.notifications;
export const getLatestNotification = (applicationContainerNotificationState: IApplicationNotificationState): commonTypes.IToastr => (applicationContainerNotificationState.notifications.length > 0) ? applicationContainerNotificationState.notifications[applicationContainerNotificationState.notifications.length - 1] : null;



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/containers/notification.reducer.ts